import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campus, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { consent, defaultValues, salutations } from "services"
import RendezVous from "../components/RendezVous"
import useLandingPage from "../services/useLandingPage"
import { academicLevelsMaster, campusSansNice, LAST_FORMS, PHONE_CALL } from "../services/landingPages"

// LP Master école de commerce : MBA / MSc (MCS_MBA__c)
const Form = () => {
  const methods = useForm({
    defaultValues: {
      ...consent,
      rendezVous: PHONE_CALL,
      lead: {
        ...defaultValues,
        MCS_MBA__c: true,
        Salutation: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control } = methods
  const { submit } = useLandingPage({
    campaignStatus: 'Contact Requested',
    formId: 'CONTACT',
    lastForm: LAST_FORMS.master,
    leadSource: 'LP : Demande de contact',
    urlKey: 'ISG-LP-MASTER'
  })

  const onSubmit = data => submit({ ...data, campusLabel: data.lead.Campus__c })

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <RendezVous campusLabel="le campus" label="Prenez rendez-vous avec l'équipe des Admissions" />
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel options={academicLevelsMaster} section={false} specialites={false} />
        <Campus label="Campus d'intérêt" options={campusSansNice} />
        <ConsentementMultiple callOptIn />
        <RequiredFields />
        <Submit label="Envoyer" onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="ISG France" />
      </Grid>
    </FormProvider>
  )
}

export default Form
